import { db } from "../../../config/firebase/firebase-config";
import {
  addAnswersCorrespondence,
  addMilestoneDb,
} from "../../../services/firebase/correspondence";

export const cloneCorrespondence = async (
  originalId: string,
  nuevoId: string,
  idEntity: string
): Promise<void> => {
  let originalDocRef = await db
    .collection("Correspondence")
    .doc(idEntity)
    .collection("CorrespondenceSection")
    .doc(originalId);
  const originalDocSnap = await originalDocRef.get();

  if (!originalDocSnap.exists) {
    alert("El documento original no existe.");
    return;
  }
  const datos = originalDocSnap.data();

  if (!datos) {
    alert("sin datos corespondencia original ");
    return;
  }

  let docSnapNew = await db
    .collection("Correspondence")
    .doc(idEntity)
    .collection("CorrespondenceSection")
    .doc(nuevoId)
    .get();

  if (docSnapNew.data()) {
    alert("nuevo dato ya esta ");
    return ;
  }

  datos.id = nuevoId;

  await db
    .collection("Correspondence")
    .doc(idEntity)
    .collection("CorrespondenceSection")
    .doc(nuevoId)
    .set(
      {
        ...datos,
        cloneid: originalId,
      },
      { merge: true }
    );

  // Clonar las subcolecciones

  const subcollectionNames = ["Answers", "Milestones"]; // Añade tus subcolecciones conocidas

  for (const subcollectionName of subcollectionNames) {
    const subDocs = await db
      .collection("Correspondence")
      .doc(idEntity)
      .collection("CorrespondenceSection")
      .doc(originalId)
      .collection(subcollectionName)
      .get();

    subDocs.forEach(async (doc) => {
      const subData = doc.data();
      if ("Milestones" === subcollectionName && subData) {
        addMilestoneDb(
          idEntity,
          nuevoId,
          subData.createAt,
          subData.processName,
          subData.owner.id,
          subData.owner.name
        );
      }
      if ("Answers" === subcollectionName && subData) {
        await db
          .collection("Correspondence")
          .doc(idEntity)
          .collection("CorrespondenceSection")
          .doc(nuevoId)
          .collection("Answers")
          .doc(subData.idAnswer)
          .set({
            ...subData,
          });
      }
    });
  }

  alert(
    "Documento copiado con éxito, recordar validar informacion en base de datos ."
  );


  // for (const subcollection of subcollections) {
  //   const subDocs = await subcollection.get();
  //   console.log("🚀 ~ subDocs:", subDocs)
  // }
  //   await setDoc(doc(db, "coleccion", nuevoId), datos);
  //   alert("Documento copiado con éxito.");
  // Opcional: Eliminar el documento original
  // await deleteDoc(docRef);
  // alert("Documento original eliminado.");
};
